import { Tooltip } from '@fluentui/react-components';
import { splitFileName } from './fileName';

export const EllipsisFileName = ({ fileName }: { fileName: string }) => {
  const { name, ext } = splitFileName(fileName);

  return (
    <Tooltip content={fileName} relationship="label">
      <span
        style={{
          display: 'flex',
          minWidth: 0,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {name}
        </span>
        {ext ? <span style={{ flexShrink: 0 }}>{ext}</span> : null}
      </span>
    </Tooltip>
  );
};

export default EllipsisFileName;
